

import React, { useState, useEffect, useRef } from "react";

import {  
  Share2,
  Bookmark,
  UserRound,
  MoreVertical,
  Trash2,
  Copy,
  CopyPlus,
  ArchiveRestore,
  Check,
  X,
  ArrowRight,
  LockKeyhole,
  Pencil,
  Lock,
  Calendar,
  FileText,
  UsersRound,
  ChartColumnIncreasing,
  TriangleAlert,
  Share,
  Link2Icon,
  ChevronDown, 
  ChevronUp,
  Coins, Icon, Gift, Wallet, MoveRight, HandCoins
} from "lucide-react";



import staricon from '../../assets/img/staricon.svg';
import walleticon from '../../assets/img/wallet-icon.png';
import upi from '../../assets/img/upi.svg';
import bank from '../../assets/img/bank.svg';
import paypal from '../../assets/img/paypal.svg';

import { myWallet } from "../../service/mywallet";

import { useWallet } from "../../context/WalletContext";




const quickActions = [
  {
    id: 1,
    action: "add",
    title: "Add Coins",
    description:"Purchase Coins To Boost Your Account And Unlock Premium Surveys.",
    icon: HandCoins,
    bg: "tw-bg-[#FFF5F5]",
    iconBg: "tw-bg-[#FFE4E4]",
    iconColor: "tw-text-[#EF4444]",
    arrowColor: "tw-text-[#EF4444]",
  },
  {
    id: 2,
    action: "redeem",
    title: "Redeem Coins",
    description:"Withdraw your coins to bank or UPI",
    icon: Gift,
    bg: "tw-bg-[#F4FCF7]",
    iconBg: "tw-bg-[#DDF8E7]",
    iconColor: "tw-text-[#16A34A]",
    arrowColor: "tw-text-[#16A34A]",
  },
];

const WalletBalanceCard = () => {

  const { walletData, loading } = useWallet();

  const [showAddCoinsModal, setShowAddCoinsModal] = useState(false);
  const [showRedeemModal, setShowRedeemModal] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

 
  return (

    <>
     <div className="sr-shell-card p-3 p-md-4 mb-3">
      <div className="tw-bg-[#fff2f2] tw-rounded-2xl tw-p-5">
        <div className="row align-items-center gy-4">
          {/* Left */}
          <div className="col-12 col-md-7">
            <p className="tw-text-[#000] ft-13 tw-font-medium mb-3">Available Balance</p>

            <div className="d-flex align-items-center gap-2 mb-4">              
              <img src={staricon} alt="staricon" className="tw-w-10 tw-h-10" />
              <h2 className="fw-bold ft-22 graytext">
                <span> {loading ? "Loading..." : `#${walletData.balance} Coins`}</span>
              </h2>
            </div>

            <div className="d-flex flex-wrap gap-3">
              <button className="bgred fw-semibold text-white w-33 ft-14 px-5 py-3 rounded-2 cursor-target text-center tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105 hover:tw-bg-[#333] ">
                Buy Coins
              </button>

              <button onClick={() => setShowRedeemModal(true)} className="btn btn-outline-danger fw-semibold              
               w-33 ft-14 px-5 py-3 rounded-2 cursor-target text-center tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105 hover:tw-bg-[#333] hover:tw-text-white hover:tw-border-[#333]">
                Redeem Requests
              </button>

            </div>
          </div>

          {/* Right */}
          <div className="col-12 col-md-5 d-flex justify-content-end">
            <img src={walleticon} alt="walleticon" className="tw-w-[124px] tw-h-[107px]" />
          </div>
        </div>
      </div>
    </div>



     <div className="sr-shell-card p-3 p-md-4">
      <h1 className="sr-page-title mb-4">
        Quick Actions
      </h1>

      <div className="row g-4">
        {quickActions.map((item) => {
          const Icon = item.icon;

          return (
            <div className="col-12 col-md-6" key={item.id}>
                <div
                  className={`${item.bg} rounded-4 p-4 tw-h-full d-flex flex-column tw-transition-all tw-duration-300 hover:tw-shadow-lg hover:tw--translate-y-1 tw-cursor-pointer`}
                  onClick={() => {
                      if (item.id === 1) setShowAddCoinsModal(true);
                      if (item.id === 2) setShowRedeemModal(true);
                  }}
                >
                  {/* Icon */}
                  <div
                    className={`${item.iconBg} tw-w-16 tw-h-16 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-4`}
                  >
                    <Icon className={item.iconColor} size={24} />
                  </div>

                  {/* Title */}
                  <h4 className="fw-bold ft-16 graytext text-center mb-2">
                    {item.title}
                  </h4>

                  {/* Description */}
                  <p className="graytext tw-text-center ft-12 mb-3">
                    {item.description}
                  </p>

                  {/* Arrow */}
                  <div className="tw-flex tw-justify-center mt-auto pt-3">
                    <MoveRight
                      size={34}
                      className={`${item.arrowColor} tw-transition-all hover:tw-translate-x-1`}
                    />
                  </div>
                </div>
              </div>
          );
        })}
      </div>
    </div>





    {showRedeemModal && (
      <div className="custom-modal-overlay">

          <div className="tw-w-full tw-max-w-[560px] bg-white rounded-4 p-5 position-relative">

              <button
                  className="position-absolute top-0 end-0 border-0 bg-transparent p-3"
                  onClick={() => setShowRedeemModal(false)}
              >
                  <X size={22} />
              </button>             

              {/* Warning */}
              <div className="rounded-3 p-3 mb-24 border-bottom pb-4" style={{background:"rgba(255, 255, 255, 1)"}}>

                  <div className="d-flex gap-3 align-items-start">

                    <div className="tw-bg-[#FFF0E4] tw-w-[40px] tw-h-[40px] tw-min-w-[40px] tw-min-h-[40px] tw-rounded-full tw-flex tw-items-center tw-justify-center">
                      <Gift size={22} className="tw-text-[#EEA23E]" />
                    </div>                     

                      <div>
                          <h3 className="ft-20 fw-semibold mb-2">Redeem Coins</h3>
                          <p className="ft-14 fw-400 mb-0 graytext">Exchange your coins for cash. The funds will be sent to your verified account listed below.</p>
                      </div>

                  </div>

              </div>

              {/* Survey Details */}
              {/* Link */}
              <p className="fw-semibold ft-14 mb-2">Enter Coins to Redeem</p>
              <div className="d-flex gap-3 mb-20 tw-p-[12px] border border-danger rounded-3 overflow-hidden justify-content-between">

                  <div className="d-flex align-items-center w-100">
                      <input type="text" className="form-control p-0 m-0 border-0 shadow-none ft-14 fw-400"  value={`#${walletData.balance}`} placeholder="#0" readOnly
                      />
                  </div>

                  <span className="ft-14 fw-400"> Coins </span>

              </div>

              {/* Link */}
              <p className="fw-semibold ft-14 mb-2">Choose Payout Method</p>
              <div className="mb-20 tw-p-[12px] border rounded-3">

                  
                   
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                      <div className="rounded-circle">
                        <img src={upi} alt="UPI" width={45} />
                      </div>

                      <div className="rounded-circle">
                        <img src={bank} alt="Bank" width={45} />
                      </div>

                      <div className="rounded-circle">
                        <img src={paypal} alt="Paypal" width={45} />
                      </div>
                    </div>

                    <button
                      className="btn p-0 border-0 bg-transparent"
                      onClick={() => setShowDetails(!showDetails)}
                    >
                      {showDetails ? (
                        <ChevronUp size={24} />
                      ) : (
                        <ChevronDown size={24} />
                      )}
                    </button>
                  </div>

                  {/* Slide Content */}
                  {showDetails && (
                    <div
                      className={`overflow-hidden transition-all ${
                        showDetails ? "mt-5 max-h-[500px]" : "max-h-0"
                      }`}
                    >
                      <div className="border-top pt-4">
                        <h5 className="fw-semibold">Choose Payment Method</h5>

                        <div className="form-check mt-3">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="payment"
                            id="upi"
                          />
                          <label className="form-check-label" htmlFor="upi">
                            UPI Payment
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="payment"
                            id="bank"
                          />
                          <label className="form-check-label" htmlFor="bank">
                            Bank Transfer
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="payment"
                            id="paypal"
                          />
                          <label className="form-check-label" htmlFor="paypal">
                            PayPal
                          </label>
                        </div>
                      </div>
                    </div>
                    )}



              </div>

              

              {/* Bottom Warning */}
              <div className="rounded-3 p-3 mb-4" style={{background:"rgba(253, 248, 237, 1)"}}>

                  <div className="d-flex gap-4">

                      <TriangleAlert
                          size={22}
                          className="text-warning flex-shrink-0 mt-1"
                      />

                      <div className="ft-14 fw-400 graytext">
                        <p className="mb-1"><strong>Please Note:</strong></p>
                        <p>We review redemption requests within 24 to 48 hours. You'll get an email notification once your request is approved.</p>
                      </div>

                  </div>

              </div>

              <div className="d-flex justify-content-end gap-3">

                  <button
                      className="redhoverbtn tw-w-full tw-max-w-[120px] ft-14 fw-bold text-black px-5 py-3 bgwhite rounded-2 cursor-target text-center border border-1 tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105 cursor-pointer"
                      onClick={() => setShowRedeemModal(false)}
                  >
                      Cancel
                  </button>

                  <button
                      className="w-33 fw-bold ft-14 text-white px-5 py-3 bgred rounded-2 cursor-target text-center hover:tw-bg-[#333] tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105"                      
                  >
                    Submit Request
                  </button>

              </div>

          </div>

      </div>
    )}

    
    
    
    </>
   
  );
};

export default WalletBalanceCard;
